










































import { Component, Vue, Mixins } from 'vue-property-decorator';
import TopMenu from '@/components/TopMenu.vue';
import { ChangePasswordArgs } from '@/common/apis/AccountApi';
import ApiProvider from '@/common/apis/ApiProvider';
import UserMixin from '@/mixins/UserMixin';
@Component({
    components: {
        TopMenu,
    },
})
export default class ChangePassword extends Mixins(UserMixin) {

    public loading: boolean = false;
    public error: string = '';
    public successfullyChanged: boolean = false;

    // Fields
    public currentPassword: string = '';
    public newPassword: string = '';
    public retypePassword: string = '';

    public mounted() {
        this.verifyLoginStatus(true);
    }

    public async save() {
        if (this.newPassword !== this.retypePassword) {
            this.error = this.$t('forgotten-password.error-passwords-must-match').toString();
            return;
        }
        try {
            this.error = '';
            this.loading = true;
            const api = ApiProvider.getAccontApi();
            await api.changePassword(new ChangePasswordArgs({
                password: this.currentPassword,
                newPassword: this.newPassword,
            }));
            this.successfullyChanged = true;
        } catch (e) {
            if (e.response && e.response.data && e.response.data.message) {
                this.error = e.response.data.message as string;
            }
        }
        this.loading = false;
    }
}
